import React from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Col, Row, Collapse, Tabs } from 'antd';

import stringres from '../../translations/stringres';
import ClienteAddEdit from './ClienteAddEdit';
import ClienteDocumentiRighe from './ClienteDocumentiRighe';
import Contatti from './Contatti/Contatti';
import EventiCliente from './EventiCliente/EventiCliente';

export default function ClienteScheda(p) {
    const { cliente } = p;
    const { Panel } = Collapse;

    return (
        <div>
            <Tabs
                type="line"
                defaultActiveKey="1"
                items={[
                    {
                        label: stringres.t('anagraficaeventi'),
                        key: '1',
                        children: (
                            <Row>
                                <Col flex="50%" style={{ paddingRight: '20px' }}>
                                    <Collapse expandIcon={() => <EditOutlined />} expandIconPosition="end" size="large">
                                        <Panel
                                            header={
                                                <div>
                                                    {stringres.t('elencodaticliente')} {cliente.ragioneSociale}
                                                </div>
                                            }
                                        >
                                            <ClienteAddEdit
                                                cliente={cliente}
                                                codCliente={cliente.codCliente}
                                                ridotto="true"
                                            />
                                        </Panel>
                                    </Collapse>
                                    <br></br>
                                    <Contatti codCliente={cliente.codCliente}></Contatti>
                                </Col>
                                <Col flex="50%">
                                    <EventiCliente codCliente={cliente.codCliente}></EventiCliente>
                                </Col>
                            </Row>
                        ),
                    },
                    {
                        label: stringres.t('fatture'),
                        key: '2',
                        children: (
                            <div>
                                <ClienteDocumentiRighe
                                    tipoDocumento="F"
                                    codCliente={cliente.codCliente}
                                ></ClienteDocumentiRighe>
                            </div>
                        ),
                    },
                    {
                        label: stringres.t('ordini'),
                        key: '3',
                        children: (
                            <div>
                                <ClienteDocumentiRighe
                                    tipoDocumento="O"
                                    codCliente={cliente.codCliente}
                                ></ClienteDocumentiRighe>
                            </div>
                        ),
                    },
                ]}
            ></Tabs>
        </div>
    );
}
